import { render, staticRenderFns } from "./StepProgressSlider.vue?vue&type=template&id=04d9064b&"
import script from "./StepProgressSlider.vue?vue&type=script&lang=js&"
export * from "./StepProgressSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../DM.Umbraco.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports